import { useWeddingBasics } from '../sections/use-wedding-basics';

/**
 * Page footer — couple names + wedding date, the last child of `.bb-ww__main`. Always rendered (real content, unlike
 * the opt-in chrome hooks) so every page gets a designed ending; themes must style `.bb-ww__footer*`.
 */
export const MotifFooter = () => {
  const { names, formattedDate } = useWeddingBasics();

  return (
    <footer className="bb-ww__footer">
      <p className="bb-ww__footer-names">{names}</p>
      {formattedDate && <p className="bb-ww__footer-date">{formattedDate}</p>}
    </footer>
  );
};
